<template>
  <main class="dashboard">
    <div class="d-flex pt-3 pb-2 mb-3 border-bottom">
      <h1 class="h2">{{ current_page.name }}</h1>
    </div>
    <div class="text" v-html="current_page.description"></div>

    <div class="card">
      <div class="card-body links">
        <div class="mb-3 filters">
          <label for="id_file" class="form-label mt-3">Загрузка ссылок, формат файла xlsx</label>
          <div class="d-flex">
            <div>

              <input class="form-control" accept=".xlsx" @change="saveFile($refs.id_file)"
                     ref="id_file" type="file"
                     id="id_file">
            </div>
            <button v-on:click="sendForm()" class="btn btn-success">Загрузить</button>
          </div>
          <a class="fst-italic" href="https://804303.selcdn.ru/ra_media/media/static/temp/negative_links.xlsx"><i
              class="bi bi-question"></i> пример файла</a>
        </div>
      </div>
    </div>
    <div class="table-flex-responsive">
      <div class="row header">
        <div class="col-1"> №</div>
        <div class="col-lg-6">Ссылка</div>
        <div class="col">Дата добавления / изменения</div>
        <div class="col"></div>
      </div>
      <template v-for="(object, index) in objects">
        <div class="row line">

          <div class="col-1 number">
            <div class="sub-head">№</div>
            {{ (index + 1) + ((page - 1) * size) }}
          </div>
          <div class="col sub-head">Ссылка</div>
          <div class="col-lg-6">
            {{ object.link }}
          </div>
          <div class="col sub-head">Дата добавления / изменения</div>
          <div class="col">
            {{ object.date }}
          </div>

          <div class="col d-flex" style="gap: 10px">
            <button style="height: 31px; white-space: nowrap;" v-if="!object.extract_yandex"
                    class="btn btn-sm btn-success"
                    @click="object.extract_yandex=true; changeStatus(object)">Изъять Yandex
            </button>
            <span v-else class="badge bg-secondary">отправлено на изъятие</span>
            <button style="height: 31px; white-space: nowrap;" v-if="!object.extract_google"
                    class="btn btn-sm btn-success"
                    @click="object.extract_google=true; changeStatus(object)">Изъять Google
            </button>
            <span v-else class="badge bg-secondary">отправлено на изъятие</span>

          </div>
        </div>
      </template>
      <div v-if="!objects.length" class="row">
        <div class="col-12 text-center">
          Не добавлено ни одной записи
        </div>
      </div>
      <div v-if="objects.length < max_length">
        <div>
          <button class="btn btn-success" v-on:click="addNote" title="Добавить запись">+</button>
        </div>
      </div>
    </div>
    <PagerList v-bind:pager="pager" v-bind:updatePage="updatePage" v-bind:page="page"></PagerList>


    <modal name="success_save" class="modal-dialog" :adaptive="true" :height="'auto'" :max-width="600">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" @click="$modal.hide('success_save');" data-bs-dismiss="modal"
                  aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <h4> Успешно загружено</h4>
          <div v-if="save_answer.length">
            <p v-for="error in save_answer">{{ error }}</p>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="$modal.hide('success_save');"
                  data-bs-dismiss="modal">Закрыть
          </button>
        </div>
      </div>
    </modal>
  </main>
</template>

<script>
import {DictionaryApi} from '@/api/dictionary'
import dataMixin from './mixins.js';

export default {
  name: 'ExtractionService',
  mixins: [dataMixin],
  data() {
    return {
      name: 'extraction',
      save_answer: [],
      file: ''
    }
  },
  methods: {
    changeStatus(obj) {
      this.submitNote(obj, false)
      this.$notify({
        group: 'alert',
        type: 'success ',
        text: 'Отправлено на изъятие'
      });
    },
    saveFile(ref) {
      this.file = ref.files[0];
    },
    sendForm: function () {
      let $this = this;
      if ($this.file) {
        let formData = new FormData();
        formData.set('file', $this.file);
        DictionaryApi.load_file($this.name, formData).then(response => {
          $this.save_answer = response.answer;
          $this.$modal.show('success_save');
          $this.file = '';
          $this.$refs.id_file.value = null;
          $this.getData()
        })
      } else {
        this.$notify({
          group: 'alert',
          type: 'error ',
          text: 'Для загрузки выберите файл'
        });
      }

    },
  }
}

</script>


<style>
textarea {
  min-width: 380px;
}

.form-select {
  min-width: 150px;
}
</style>
